import { Component } from '@angular/core';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Router } from '@angular/router';
import { SharedService } from 'app/shared/services/shared.service';
import { HttpService } from 'app/shared/services/http.service';
import { DictionaryService } from 'app/shared/services/dictionary.service';
import { ModalsService } from 'app/shared/services/modals.service';
import { UserService } from 'app/shared/services/user.service';
import { GoogleAnalyticsService } from 'app/shared/services/google-analytics.service';

@AutoUnsubscribe()
@Component({
  selector: 'navbar-component',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent {
  public searchString: string;
  public isLoading: boolean;
  public searchResults: Array<any>;
  public searchBoxFocus: boolean;
  public searchBoxTimeout: any;
  public lastSearch: string;
  public firstSearchFlag: boolean;
  public searchSubscription: any;
  public subscriptions: Array<any>;

  constructor(
    public router: Router,
    public sharedService: SharedService,
    public httpService: HttpService,
    public dictionaryService: DictionaryService,
    public modalsService: ModalsService,
    public userService: UserService,
    public ga: GoogleAnalyticsService
  ) {
    this.searchString = '';
    this.isLoading = false;
    this.searchResults = [];
    this.searchBoxFocus = false;
    this.lastSearch = '';
    this.firstSearchFlag = false;
    this.subscriptions = [];
  }

  ngOnDestroy() {}

  onHelpButtonClick() {
    this.modalsService.showModal({ component: 'help', title: this.dictionaryService.get('LEAVE_US_A_MESSAGE') });
  }

  toggleSearchBox(state: boolean, timeout: number = 0) {
    clearTimeout(this.searchBoxTimeout);
    this.searchBoxTimeout = setTimeout(() => {
      this.searchBoxFocus = state;
    }, timeout);
  }

  search() {
    if (this.validateSearch()) {
      if (this.searchString !== this.lastSearch) {
        this.isLoading = true;
        this.searchBoxFocus = true;
        this.lastSearch = this.searchString;
        this.searchSubscription = this.httpService
          .post('search/byEntity', { searchString: this.searchString })
          .subscribe((response) => {
            const data = response.data;
            for (let i = 0; i < data.length; i++) {
              switch (data[i].type) {
                case 'player':
                  data[i].link = '/supply/manage/' + data[i].id;
                  data[i].typeName = this.dictionaryService.get('SUPPLY');
                  break;
                case 'vast':
                  data[i].link = '/demand/manage/' + data[i].id;
                  data[i].typeName = this.dictionaryService.get('DEMAND');
                  break;
                case 'list':
                  data[i].link = '/list/manage/' + data[i].id;
                  data[i].typeName = this.dictionaryService.get('LIST');
                  break;
                case 'rtb_vendor':
                  data[i].link = '/rtb-partners/manage/' + data[i].id;
                  data[i].typeName = this.dictionaryService.get('RTB_PARTNER');
                  break;
              }
            }
            this.searchResults = data;
            this.isLoading = false;
            this.firstSearchFlag = true;
          });
        this.subscriptions.push(this.searchSubscription);
        this.sharedService.sendMessage('SEARCH', this.searchString);
      }
    }
  }

  focusOnSearch() {
    const searchBox: HTMLInputElement = <HTMLInputElement>document.getElementById('searchBox');
    if (searchBox) {
      searchBox.focus();
    }
  }

  validateSearch() {
    const minimum: boolean =
      !this.sharedService.isEmpty(this.searchString) &&
      this.searchString.length >= 3 &&
      /^(?=.*[a-zA-Z0-9])/.test(this.searchString);
    const noInvalidChars: boolean = this.searchString.indexOf(`\\`) === -1;
    if (!minimum && noInvalidChars) {
      this.sharedService.showFlashMessage(this.dictionaryService.get('SEARCH_QUERY_ERROR_MINIMUM'), 'warning');
    } else if (minimum && !noInvalidChars) {
      this.sharedService.showFlashMessage(this.dictionaryService.get('SEARCH_QUERY_ERROR_BACKSLASH'), 'warning');
    } else if (!minimum && !noInvalidChars) {
      this.sharedService.showFlashMessage(this.dictionaryService.get('SEARCH_QUERY_ERROR_BOTH'), 'warning');
    }
    return minimum && noInvalidChars;
  }

  goToSearchResult(entityType: string, entityId: number) {
    const url: string = this.userService.isAdmin() ? 'admin/cedato-labs' : 'reports';
    if (entityType === 'player') {
      this.router.navigate([url], { queryParams: { d: '1=' + entityId } });
    } else if (entityType === 'vast') {
      this.router.navigate([url], { queryParams: { d: '2=' + entityId } });
    }
  }

  clearSearch() {
    this.searchString = '';
    this.isLoading = false;
    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }
  }

  onKeyDown($event: any) {
    if ($event.which === 13) {
      this.search();
    }
  }
}
